module.exports = __webpack_public_path__ + "static/media/signage-indoor-img14.63370003.jpg";